import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Items() {
  const [searchTerm, setSearchTerm] = useState('');
  const [boxes, setBoxes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api(`/boxes`)
      .then(res => res.json())
      .then(data => {
        setBoxes(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const filtered = boxes.filter(box =>
    (box.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (box.location || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (box.description || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Boxes</h1>
            <Link to="/storage/boxes/new" className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
              Add Box
            </Link>
          </div>
          <input
            type="text"
            placeholder="Search boxes by name or description..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Location</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Created</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((box) => (
                <tr key={box.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                    <Link to={`/storage/boxes/${box.id}`} className="text-green-600 hover:text-green-800">{box.name}</Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{box.location || '—'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{box.description || '—'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">
                    {new Date(box.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {loading && <div className="text-center py-12 text-gray-500">Loading...</div>}
          {!loading && filtered.length === 0 && (
            <div className="text-center py-12 text-gray-500">No boxes found.</div>
          )}
        </div>
      </div>
    </Layout>
  );
}
